/**
 * Pure crop geometry helpers.
 * Positions are image-space offsets of the crop circle centre relative to the image.
 * Scale is the factor applied to the natural image so that image pixels map to crop viewport pixels.
 */

export function initialScaleToCover(imageWidth, imageHeight, cropDiameter) {
  if (!imageWidth || !imageHeight || !cropDiameter) {
    return 1;
  }
  return cropDiameter / Math.min(imageWidth, imageHeight);
}

export function clampOffset(offsetX, offsetY, imageWidth, imageHeight, scale, cropDiameter) {
  const scaledWidth = imageWidth * scale;
  const scaledHeight = imageHeight * scale;
  const half = cropDiameter / 2;

  const minX = half - scaledWidth / 2;
  const maxX = scaledWidth / 2 - half;
  const minY = half - scaledHeight / 2;
  const maxY = scaledHeight / 2 - half;

  // When the scaled image exactly matches the crop, offset must be 0.
  const clampAxis = (value, min, max) => {
    if (min > max) {
      return 0;
    }
    return Math.min(max, Math.max(min, value));
  };

  return {
    offsetX: clampAxis(offsetX, minX, maxX),
    offsetY: clampAxis(offsetY, minY, maxY),
  };
}

export function clampScale(scale, imageWidth, imageHeight, cropDiameter, maxScale = 8) {
  const minScale = initialScaleToCover(imageWidth, imageHeight, cropDiameter);
  return Math.min(maxScale, Math.max(minScale, scale));
}
